import React from "react";
import PropTypes from "prop-types";
import {
    Modal,
    Backdrop,
    Fade,
    Box,
    IconButton,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const CustomModal = React.memo(({ open, handleClose, children }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: {
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                    },
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: isSmallScreen ? "90%" : 400,
                        maxHeight: "90vh",
                        p: 2,
                        backgroundColor: "transparent",
          backdropFilter: "blur(10px)",
          borderRadius: 2,
          boxShadow: theme.shadows[5],
          border: "1px solid white",
                        boxSizing: "border-box",
                        outline: "none",
                        overflowY: "auto",
                    }}
                >
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {children}
                </Box>
            </Fade>
        </Modal>
    );
});

CustomModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default CustomModal;
